module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/0c99f9ea906ff38c8d007ab9f7607bc6.png";